import React from "react";
import { Box, Stack, Typography, Chip, SvgIcon } from "@mui/material";
import YouTubeIcon from "@mui/icons-material/YouTube";
import InstagramIcon from "@mui/icons-material/Instagram";

/** Simple TikTok SVG */
function TikTokIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 48 48">
      <path d="M33 13.5c2.2 1.7 4.9 2.7 7.8 2.9v5.7c-2.9-.1-5.7-1-7.8-2.3v10.2c0 7.1-5.7 12.8-12.8 12.8S7.4 36.1 7.4 29c0-7.1 5.7-12.8 12.8-12.8 1 0 2 .1 3 .4v6.2a7.1 7.1 0 00-3-.7c-3.9 0-7.1 3.2-7.1 7.1 0 3.9 3.2 7.1 7.1 7.1s7.1-3.2 7.1-7.1V6.6h6.7c.1 2.7 1.1 5.2 3 6.9z" />
    </SvgIcon>
  );
}

export default function PlatformBadges() {
  return (
    <Box
      sx={{
        p: { xs: 2, md: 3 },
        borderRadius: 3,
        bgcolor: "background.paper",
        boxShadow: 6,
        mb: 2,
      }}
    >
      <Stack spacing={1}>
        <Typography variant="h6" fontWeight={700} color="text.primary">
          Supported Platforms
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Publish on these platforms and include our required hashtags in your
          description.
        </Typography>

        <Stack direction="row" spacing={1.5} sx={{ mt: 1, flexWrap: "wrap" }}>
          <Chip
            icon={<YouTubeIcon sx={{ color: "error.main" }} />}
            label="YouTube"
            variant="outlined"
            sx={{ borderColor: "divider", color: "text.primary" }}
          />
          <Chip
            icon={<InstagramIcon sx={{ color: "#E1306C" }} />}
            label="Instagram"
            variant="outlined"
            sx={{ borderColor: "divider", color: "text.primary" }}
          />
          <Chip
            icon={<TikTokIcon />}
            label="TikTok"
            variant="outlined"
            sx={{ borderColor: "divider", color: "text.primary" }}
          />
        </Stack>
      </Stack>
    </Box>
  );
}
